import React from 'react';
import { Link } from 'react-router-dom';

const FooterComponent = () => {
  return (
    <footer className='footer-container'>
      {/* Top trust band */}
      <div className='footer-top'>
        <div className='footer-brand'>
          <img src='/assets/img/jumboLogo.png' alt='Jumbo Holidayz' className='footer-logo' />
          <div>
            <h3 className='footer-title'>Jumbo Holidayz</h3>
            <p className='footer-tagline'>Premium private stays. Zero shared amenities. Managed end‑to‑end.</p>
          </div>
        </div>

        <div className='footer-cta'>
          <Link to='/host' className='footer-cta-btn'>List your property</Link>
        </div>
      </div>

      {/* Middle navigation grid */}
      <div className='footer-grid modern-grid'>
        <div className='footer-col'>
          <h4>Support</h4>
          <ul className='footer-links'>
            <li><Link className='terms-link' to='/ContactUs'>Contact us</Link></li>
            <li><Link className='terms-link' to='/ContactUs'>Get help with your stays</Link></li>
            <li><Link className='terms-link' to='/ContactUs'>Get help with your property listing</Link></li>
            <li><Link className='terms-link' to='/privacypolicy'>Privacy Policy</Link></li>
            <li><Link className='terms-link' to='/termscondition'>Terms & Conditions</Link></li>
          </ul>
        </div>

        <div className='footer-col'>
          <h4>Explore</h4>
          <ul className='footer-links'>
            <li><Link className='terms-link' to='/properties?location=Mahabaleshwar'>Stays in Mahabaleshwar</Link></li>
            <li><Link className='terms-link' to='/properties?location=Ambernath'>Stays in Ambernath</Link></li>
            <li><Link className='terms-link' to='/properties?location=Lonavla'>Stays in Lonavla</Link></li>
            <li><Link className='terms-link' to='/properties?location=Alibag'>Stays in Alibag</Link></li>
          </ul>
        </div>

        {/* <div className='footer-col'>
          <h4>Company</h4>
          <ul className='footer-links'>
            <li><Link className='terms-link' to='/Blog'>Blog</Link></li>
            <li><Link className='terms-link' to='/Careers'>Careers</Link></li>
            <li><Link className='terms-link' to='/AboutUs'>About us</Link></li>
            <li><Link className='terms-link' to='/Safety'>Safety & trust</Link></li>
          </ul>
        </div> */}

        <div className='footer-col'>
          <h4>We accept</h4>
          <div className='footer-payments'>
            <img src='/assets/img/weaccept.png' alt='Visa' />
            {/* <img src='/assets/img/payments/mastercard.svg' alt='Mastercard' />
            <img src='/assets/img/payments/upi.svg' alt='UPI' />
            <img src='/assets/img/payments/amex.svg' alt='American Express' /> */}
          </div><br/>
          <h4 className='mt-2'>Download</h4>
          <div className='footer-badges'>
            <a href='https://link.jumboholidayz.com/getapp/' target='_blank'><img src='/assets/img/appstores.png' alt='App Store' /></a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className='footer-bottom'>
        <div className='footer-social'>
        <a href='https://www.instagram.com/jumboholidayz_official/' target='_blank' rel='noreferrer' aria-label='Instagram' className='social-link' title='Instagram'>
  <svg viewBox='0 0 24 24' className='social-svg' role='img' aria-hidden='true' focusable='false'>
    <rect x='2' y='2' width='20' height='20' rx='6' ry='6' stroke='currentColor' strokeWidth='2.2' fill='none'/>
    <circle cx='12' cy='12' r='5' stroke='currentColor' strokeWidth='2.2' fill='none'/>
    <circle cx='17' cy='7' r='1.8' fill='currentColor'/>
  </svg>
</a>
<a href='https://www.facebook.com/jumboholidayz/' target='_blank' rel='noreferrer' aria-label='Facebook' className='social-link' title='Facebook'>
  <svg viewBox='0 0 24 24' className='social-svg' role='img' aria-hidden='true' focusable='false'>
    <path d='M22.675 0H1.325C.593 0 0 .593 0 1.325v21.351C0 23.407.593 24 1.325 24H12.82V14.706h-3.2V11.1h3.2V8.414c0-3.166 1.933-4.891 4.754-4.891 1.352 0 2.514.1 2.852.145v3.307h-1.958c-1.535 0-1.832.73-1.832 1.802V11.1h3.665l-.477 3.606h-3.188V24h6.255C23.407 24 24 23.407 24 22.676V1.325C24 .593 23.407 0 22.675 0z'/>
  </svg>
</a>
<a href='https://www.youtube.com/@jumboholidayz' target='_blank' rel='noreferrer' aria-label='YouTube' className='social-link' title='YouTube'>
  <svg viewBox='0 0 24 24' className='social-svg' role='img' aria-hidden='true' focusable='false'>
    <path d='M23.5 6.2s-.2-1.6-.9-2.3c-.8-.9-1.7-.9-2.1-1C16.8 2.5 12 2.5 12 2.5h-.1s-4.8 0-8.4.4c-.5.1-1.4.1-2.1 1-.7.7-.9 2.3-.9 2.3S0 8.1 0 10v1.9c0 1.9.2 3.8.2 3.8s.2 1.6.9 2.3c.8.9 1.9.9 2.4 1 1.8.2 7.5.4 7.5.4s4.8 0 8.4-.4c.5-.1 1.4-.1 2.1-1 .7-.7.9-2.3.9-2.3s.2-1.9.2-3.8V10c0-1.9-.2-3.8-.2-3.8zM9.6 14.8V8.7l6.3 3-6.3 3.1z'/>
  </svg>
</a>
        </div>
        <p className='copyright'>© {new Date().getFullYear()} Jumbo Holidayz. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default FooterComponent;
